import { createFileRoute } from "@tanstack/react-router";
import { SERVICES_FAQS_EN } from "@/lib/services-faqs";
import { alternatePath } from "@/lib/i18n";
import { breadcrumbJsonLd, faqJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";
import { buildCorporateHead } from "@/lib/corporate-seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/services")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildCorporateHead({
    locale: "en",
    title: "Shopify Engineering Services for Established Brands | Shugert",
    description:
      "Find the right Shopify intervention for performance, conversion, technical SEO, migrations, development, integrations, Shopify Plus and ongoing engineering.",
    path: "/services",
    altPath: alternatePath("/services", "es"),
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }]),
      faqJsonLd(SERVICES_FAQS_EN),
      serviceJsonLd({
        name: "Shopify Engineering Services",
        description:
          "Senior Shopify interventions for performance, conversion, technical SEO, development, migrations, applications, integrations, analytics, ongoing engineering and Shopify Plus.",
        path: "/services",
        serviceType: "Shopify Engineering Services",
        locale: "en",
      }),
      webPageJsonLd({
        name: "Shopify Engineering Services for Established Brands",
        path: "/services",
        description:
          "A customer-led decision hub for choosing the responsible Shopify intervention based on the business constraint, expected outcome and technical dependencies.",
        inLanguage: "en-US",
      }),
    ],
  }),
});
